module.exports = __webpack_public_path__ + "img/2.708e1ed9.jpeg";